export function handleFileRename(
  applicationNo: string,
  type: string,
  index: number | null,
): string {
  return `${applicationNo}_${type}${index === null ? '' : '_' + index}`;
}
